import _ from 'lodash';
import { IGlobalState } from '~reducer';
import IToast from './IToast';

export function toastsSelector(state: IGlobalState): IToast[] {
    return state.global.toasts;
}
